import React, { FunctionComponent, useContext } from "react";
import UserAccessControlUtils from "../../utils/UserAccessControlUtils";
import { AuthContext } from "../../providers/AuthProvider";

type CapabilityProtectedComponentProps = {
  requiredCapability: string | string[];
};

const CapabilityProtectedComponent: FunctionComponent<
  CapabilityProtectedComponentProps
> = ({ requiredCapability, children }) => {
  const auth = useContext(AuthContext);
  return auth &&
    UserAccessControlUtils.hasCapability(
      auth.ta_capabilities,
      requiredCapability
    ) ? (
    // eslint-disable-next-line react/jsx-no-useless-fragment
    <>{children}</>
  ) : (
    <div />
  );
};

export default CapabilityProtectedComponent;
